import { useDispatch } from 'react-redux';
import { setAnnualPremiumAmount } from '../../../../../../features/actuarial/annual-premium-eoi.slice';
import { CloseIconSVG, EditIconSVG, SaveIconSVG } from '../../../../../../assets/icon/svg';
import { useComputationActions } from '../../../../../../hooks/actions/user-computation-actions';
import { useProposalComputation } from '../../../../../../hooks/proposal/use-proposal-computation';

export default function TotalAnnualPremium() {

    const dispatch = useDispatch();
    const { 
        isLoadingComputeTotalAmountPremium,
        cantEdit,
        handleSaveTotalAmountPremium,
        handleIsUpdateTotalAmountPremium,
        handleCancelUpdateTotalAmountPremium,
    } = useComputationActions()
    const { annualPremiumAmount, isUpdateAnnualPremium } = useProposalComputation()
    const isLoading = isLoadingComputeTotalAmountPremium

    // const formatNumber = (value: number | null | undefined) => value == null ? "" : value.toLocaleString();
    const formatNumber = (value?: number | null) => value == null ? "" : new Intl.NumberFormat("en-PH").format(value);

    const handleChangeAmount = (value: string) => {
        const onlyDigits = value.replace(/\D/g, '');
        const numericValue = onlyDigits === '' ? 0 : Number(onlyDigits);

        dispatch(setAnnualPremiumAmount(numericValue))
    }

    return (
        <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
            {/* HEADER */}
            <div className="flex items-center justify-between gap-3 border-b border-gray-200 bg-gray-50 px-3 py-3 sm:px-4">
                <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                        <span className="h-2 w-2 shrink-0 rounded-full bg-[#186cb2]" />
                        <h3 className="truncate text-xs font-semibold text-gray-800">
                            Total Annual Premium
                        </h3>
                    </div>
                    <p className="mt-0.5 text-[10px] leading-4 text-gray-500 sm:text-[11px]">
                        Premium computed from the selected plan and riders.
                    </p>
                </div>
                {!isUpdateAnnualPremium ? (
                    <button
                        type="button"
                        aria-label="Edit Amount"
                        title="Edit Amount"
                        disabled={cantEdit || isLoading}
                        onClick={handleIsUpdateTotalAmountPremium}
                        className="flex size-9 shrink-0 items-center justify-center rounded-md border border-gray-300 bg-white text-[#186cb2] transition-colors hover:bg-[#186cb2]/5 disabled:cursor-not-allowed disabled:opacity-50 sm:h-auto sm:w-auto sm:gap-1.5 sm:px-3 sm:py-1.5"
                    >
                        <EditIconSVG size={14} />
                        <span className="hidden sm:inline text-xs">Edit Amount</span>
                    </button>
                ) : (
                    <div className="flex shrink-0 items-center gap-2">
                        <button
                            type="button"
                            aria-label="Cancel"
                            title="Cancel"
                            disabled={cantEdit || isLoading}
                            onClick={handleCancelUpdateTotalAmountPremium}
                            className="flex size-9 items-center justify-center rounded-md border border-gray-300 bg-white text-gray-700 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 sm:h-auto sm:w-auto sm:gap-1.5 sm:px-3 sm:py-1.5"
                        >
                            <CloseIconSVG size={14} />
                            <span className="hidden sm:inline text-xs">Cancel</span>
                        </button>

                        <button
                            type="button"
                            aria-label="Save"
                            title="Save"
                            disabled={cantEdit || isLoading}
                            onClick={handleSaveTotalAmountPremium}
                            className="flex size-9 items-center justify-center rounded-md border border-[#186cb2] bg-[#186cb2] text-white transition-colors hover:bg-[#155b96] disabled:cursor-not-allowed disabled:opacity-50 sm:h-auto sm:w-auto sm:gap-1.5 sm:px-3 sm:py-1.5"
                        >
                            <SaveIconSVG size={14} />
                            <span className="hidden sm:inline text-xs">Save</span>
                        </button>
                    </div>
                )}
            </div>

            <div className="p-3">
                <div className="flex flex-col items-center justify-center rounded-md border border-gray-200 bg-gray-50 px-4 py-5">
                    <span className="text-[10px] font-medium uppercase tracking-wide text-gray-400">
                        Annual Premium
                    </span>
                    <div className="mt-1.5 flex min-w-0 items-baseline justify-center gap-1.5">
                        <span className="text-lg font-semibold text-gray-500">₱</span>
                        {isUpdateAnnualPremium ? (
                            <input
                                type="text"
                                inputMode="numeric"
                                className="w-full max-w-[240px] border-0 bg-transparent text-center text-2xl font-bold text-[#186cb2] outline-none"
                                value={formatNumber(annualPremiumAmount ?? 0)}
                                onChange={(e) => handleChangeAmount(e.target.value)}
                            />
                        ) : (
                            <span className="text-2xl font-bold text-[#186cb2]">
                                {formatNumber(annualPremiumAmount ?? undefined)}
                            </span>
                        )}
                    </div>
                    <p className="mt-1.5 text-[10px] text-gray-400">
                        This amount will be reflected in the proposal.
                    </p>
                </div>
            </div>
        </div>
    )
}
